/**
 * class will handle the cache data for polling calls.
 * @author Meghna Sadhwani
 */
import moment from 'moment';

class Cache {
    constructor() {
        this.cache = {};
    }
      
    /**
     * Method will be used to store cache data
     * @param  {String} key            key
     * @param  {Object} cacheData      Data
     * @param  {Object} cacheInterval  Cache Time
     */
    setCacheData(key, cacheData, cacheInterval = 9) {
        var value = { data: cacheData, cacheTime: moment().utc().add(cacheInterval, 'seconds') };           
        this.cache[key] = value;
    }

    /**
     * Method can be used to retrieve cache data from key
     * @param  {String} key            cache key
     * @return {Object}                Promise Object
     */
    getCacheData(key) {
        const value = this.cache[key];
        if(!value || moment().utc().isAfter(value.cacheTime)){
            return null;
        }
        return value.data;
    }
    
    /**
     * Method can be used to clear cache value
     * @param  {String} key            cache key
     */
    clearCacheValue(key) {
        this.cache[key] = null;
    }
    
}

export default new Cache();
